
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12426',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12426",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.473",
  "data-fetching-client": "static-1.9716",
  "foundations-components": "static-1.8030",
  "foundations-components-legacy": "static-1.1055",
  "foundations-theming": "static-1.4476",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8068",
  "hub-http-shared-msw-handlers": "static-1.10086",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11525",
  "I18n": "static-7.1633",
  "jasmine-runner": "static-1.6515",
  "marketplace-storefront-base": "static-1.12487",
  "quartz": "static-1.7093",
  "react-dlb": "static-1.80",
  "react-rhumb": "static-1.16729",
  "reactive-variable-buffer-atom": "static-1.2910",
  "reporting-testing-lib": "static-1.9708",
  "settings-ui-lib": "static-1.12571",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7233",
  "ui-addon-i18n": "static-1.11203",
  "ui-addon-react-router-dom": "static-1.9593",
  "unified-auth": "static-1.554",
  "unified-auth-core-lib": "static-1.836",
  "usage-tracker": "static-1.7401",
  "usage-tracker-core": "static-1.7251",
  "customer-data-property-utils": "static-1.8143",
  "hub-http": "static-1.6274",
  "integrations-lib": "static-1.16329",
  "marketplace-ui-common": "static-1.19951",
  "property-management-iframe": "static-1.13326",
  "quartz-config": "static-1.871",
  "quartz-core": "static-1.6312",
  "quartz-routing": "static-1.523",
  "quick-fetch": "static-1.3958",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4704",
  "ts-schema": "static-1.4120",
  "ui-universal-auth": "static-1.9040",
  "UIComponents": "static-3.8471",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3440",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3370",
  "quartz-webpack": "static-1.3317",
  "bend-plugin-quartz-routing": "static-1.171",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4299",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4921",
  "foundations-theming-specialty": "static-1.2192",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9475",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5384",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.488",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2073",
  "ui-fonts": "static-1.787",
  "ui-images": "static-2.1165",
  "bend-plugin-foundations-theming": "static-1.2959",
  "foundations-theming-base": "static-1.3461",
  "stylex": "static-1.34",
  "HeadJS": "static-2.765",
  "hs-test-utils-bend-plugin": "static-1.3179",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4377",
  "ai-components-ui-library": "static-1.9095",
  "ai-rendering-library": "static-1.10346",
  "chirp-fetch": "static-1.1939",
  "connections-embed-lib": "static-1.1086",
  "copilot-toolkit": "static-1.11269",
  "feedback-loader": "static-1.29390",
  "laboratory-lib": "static-3.7207",
  "marketplace-embed": "static-1.22232",
  "marketplace-ui-details": "static-1.9846",
  "marketplace-ui-reviews": "static-1.19906",
  "marketplace-ui-tracking": "static-1.14121",
  "sanitize-text": "static-1.8194",
  "ui-addon-video-player": "static-1.8755",
  "usage-tracker-multi": "static-1.5815",
  "usage-tracker-session-replay": "static-1.5087",
  "wootric-nps": "static-1.7022",
  "quartz-head": "static-1.758",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4703",
  "immer": "static-1.33",
  "immerable": "static-1.4205",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2525",
  "reporting-data": "static-1.67775",
  "cssUtils": "static-1.804",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11832",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10260",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10416",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7391",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18483",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4565",
  "foundations-components-test-utils": "static-1.5513",
  "quartz-i18n": "static-1.768",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.28",
  "google-sheets-integration-lib": "static-1.385",
  "microsoft-drive-integration-lib": "static-1.520",
  "slack-ui-library": "static-1.10443",
  "fsm": "static-1.3782",
  "customer-data-objects": "static-1.7728",
  "property-translator": "static-1.5450",
  "hs-locale-management": "static-1.121",
  "frontend-preferences-client": "static-1.7978",
  "hs-promise-utils": "static-1.5643",
  "hubspot-apollo-client": "static-1.4929",
  "integrations-error-boundary-lib": "static-1.13744",
  "integrations-tracking-lib": "static-1.5655",
  "native-integrations-shared-strings": "static-1.7833",
  "reselect": "static-2.16",
  "sanitize": "static-1.4528",
  "superstore": "static-1.4812",
  "ui-shepherd-react": "static-3.10263",
  "ai-settings-ui-library": "static-1.7965",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4691",
  "immutable-less": "static-1.4704",
  "marketplace-ui-client-types": "static-1.17358",
  "nav-meta": "static-1.29802",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10298",
  "ui-addon-upgrades": "static-9.18068",
  "inbound-db-properties-service-client": "static-1.3886",
  "property-management-common": "static-1.5614",
  "ui-addon-iframeable": "static-1.9111",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.768",
  "quartz-test": "static-1.768",
  "quartz-tracking": "static-1.472",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.114",
  "bender-build-tools": "static-1.3254",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21515",
  "ContentUtils": "static-1.68513",
  "customer-data-objects-ui-components": "static-1.13083",
  "sassPrefix": "static-1.157",
  "breeze-engine-core": "static-1.112",
  "breeze-onboarding-components": "static-1.136",
  "avatar-components": "static-1.2550",
  "customer-data-filters-ui": "static-1.39975",
  "customer-data-reference-ui-components": "static-1.13220",
  "embedded-academy-lib": "static-1.14508",
  "ExportDialog": "static-6.10437",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41440",
  "reporting-snowflake": "static-1.56393",
  "reporting-ui-components": "static-2.65046",
  "reporting-visualizations": "static-1.59851",
  "ui-addon-teams": "static-1.21625",
  "magpie-lib": "static-1.5585",
  "navigation-components": "static-1.18165",
  "breeze-engine-lib": "static-1.834",
  "magpie-types": "static-1.5045",
  "simple-logging-lib": "static-1.3102",
  "ai-studio-lib": "static-1.11761",
  "app-governance-lib": "static-1.1715",
  "developer-experience-shared-components": "static-1.10564",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8052",
  "ui-product-approvals": "static-1.28298",
  "ui-tool-access": "static-1.10200",
  "usage-based-billing-components-lib": "static-1.9170",
  "usage-tracker-anonymous": "static-1.5818",
  "usage-tracker-public": "static-1.7212",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3626",
  "persist-promise": "static-1.3750",
  "reference-resolvers": "static-1.8223",
  "ui-extensibility-client-types": "static-1.3977",
  "hubspot-apollo-cache": "static-1.388",
  "universal-page-editor-lib": "static-1.3068",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2920",
  "merchandise-lib": "static-1.265",
  "atom": "static-1.5126",
  "purchase-motions-components": "static-1.6006",
  "salesImages": "static-1.526",
  "batch-promise": "static-1.1593",
  "crm-component-utils": "static-1.39212",
  "crm-properties-common-lib": "static-1.5939",
  "customer-data-properties": "static-1.51746",
  "framework-data-schema-resolvers": "static-1.6939",
  "property-value-citations": "static-1.2360",
  "reference-resolvers-lite": "static-1.8148",
  "ui-business-units-lib": "static-1.9109",
  "navigation-messaging": "static-1.7492",
  "hubspotter-http-shared-msw-handlers": "static-1.10084",
  "cms-field-types": "static-1.4864",
  "content-icons-ui": "static-1.2239",
  "customer-data-ui-utilities": "static-1.9877",
  "events-data-lib": "static-1.279",
  "conversations-skeleton-state": "static-1.7300",
  "crm-message-bus": "static-1.43102",
  "customer-data-filters-ui-msw-helpers": "static-1.22410",
  "FormUrlGenerator": "static-2.4772",
  "framework-builder-read-service-client": "static-1.4045",
  "framework-data-schema-quick-fetch": "static-1.6844",
  "multi-account-reference-resolvers": "static-1.1033",
  "onboarding-tours": "static-1.16700",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13824",
  "academy-common-lib": "static-1.13968",
  "content-assistance-lib": "static-1.7830",
  "dashboard-lib": "static-1.81737",
  "file-manager-components": "static-1.23754",
  "getting-started-shared-tasks": "static-1.18569",
  "hubspot-prosemirror": "static-1.18371",
  "hubspot-prosemirror-plugins": "static-1.18363",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19919",
  "share-with-third-party-component-lib": "static-1.8756",
  "ui-addon-draggable": "static-3.4814",
  "ui-asset-management-lib": "static-1.11104",
  "user-context": "static-1.5159",
  "growth-payments-core": "static-1.25524",
  "reporting-plugins": "static-1.10400",
  "reporting-reports": "static-1.67453",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.775",
  "nest": "static-1.283",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10679",
  "framework-listing-lib": "static-2.28828",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30842",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4302",
  "ui-product-approvals-common": "static-1.193",
  "onboarding-scopes": "static-1.6513",
  "onboarding-tours-client": "static-1.4914",
  "platform-infra-nav-components": "static-1.7712",
  "subscription-experience-data-types": "static-1.15000",
  "crm-record-cards-service-types": "static-1.3630",
  "location-customization-utils-lib": "static-1.9408",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6009",
  "signup-constants": "static-1.18949",
  "signup-ui-url-generator": "static-2.8105",
  "card-properties-lib": "static-1.44348",
  "commerce-subscription-lib": "static-1.37265",
  "crm-actions": "static-1.6389",
  "crm-cards-sdk": "static-1.43738",
  "customer-data-properties-shared-msw-handlers": "static-1.9413",
  "customer-data-tracking": "static-1.6941",
  "hs-resources": "static-1.219",
  "pulse": "static-1.637",
  "calling-global-api": "static-1.64688",
  "calling-internal-common": "static-1.31355",
  "calling-lifecycle-internal": "static-1.66070",
  "calling-lifecycle-messages": "static-1.58364",
  "commerce-products-lib": "static-1.9747",
  "conditional-properties-service-client": "static-1.3838",
  "crm-links": "static-1.6357",
  "crm-pipelines-api-client-types": "static-1.4180",
  "external-options-client-types": "static-1.4199",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4263",
  "meetings-icalendar-utils-lib": "static-1.684",
  "multi-currency-client-types": "static-1.3732",
  "object-builder-ui-client": "static-1.48920",
  "pipeline-validation-client-types": "static-1.4006",
  "smart-property-lib": "static-1.7372",
  "tiered-pricing": "static-1.1330",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11041",
  "fdsr-migration-layer": "static-1.58",
  "react-dnd-compat": "static-1.4665",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1032",
  "growth-data-modal": "static-1.5507",
  "growth-onboarding-confetti": "static-1.3118",
  "growth-onboarding-next-action-utils": "static-1.2067",
  "onboarding-tours-utils": "static-1.766",
  "ui-shepherd-tracker": "static-1.7644",
  "academy-service-client": "static-1.3734",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39253",
  "FileManagerLib": "static-1.39394",
  "video-embed": "static-1.35949",
  "ui-coaching-tips": "static-1.28703",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11457",
  "video-data-lib": "static-1.35115",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8516",
  "payment-link-components": "static-1.23646",
  "ui-addon-emoji-picker": "static-1.9938",
  "EmailSignatureEditor": "static-1.24485",
  "viral-links-lib": "static-1.7120",
  "data-token-picker": "static-1.16494",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.278",
  "timezone-utils": "static-2.5295",
  "seat-types-lib": "static-1.136",
  "getting-started-shared-tasks-store": "static-1.17687",
  "ui-addon-opt": "static-4.8414",
  "campaign-roi-lib": "static-1.9256",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25562",
  "framework-data-table": "static-2.12033",
  "marketing-platform-lib": "static-1.6912",
  "nudge-client-utils": "static-1.2692",
  "nudge-custom-ui-functions": "static-1.1126",
  "switchboard-lib": "static-1.272",
  "app-users-service-client": "static-1.5652",
  "app-users-service-types": "static-1.5060",
  "mini-checkout-client": "static-1.26933",
  "onboarding-utils": "static-1.5409",
  "permissions-shared-i18n-strings-fe": "static-1.2051",
  "ui-coaching-tips-shared-config": "static-1.28688",
  "edison-service-client-types": "static-1.440",
  "crm_data": "static-4.92120",
  "customer-data-sidebar": "static-2.46157",
  "enrichment-properties-lib": "static-1.16490",
  "ui-addon-draggable-compat": "static-2.4310",
  "commerce-billing-lib": "static-1.19238",
  "commerce-shared-components-lib": "static-1.18658",
  "commerce-tools-ui-lib": "static-1.10512",
  "crm-fe-perf": "static-1.22954",
  "event-emitter": "static-1.999",
  "bend-plugin-pulse": "static-1.140",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31362",
  "shared-worker-versioning": "static-1.11088",
  "calling-usage-tracker": "static-1.6593",
  "voice-sms-access-library": "static-1.1204",
  "commerce-permissions": "static-1.825",
  "products-iframe-lib": "static-1.8076",
  "products-ui-components-shared-msw-handlers": "static-1.10468",
  "data-agent-kit": "static-1.274",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10169",
  "policy-lib": "static-1.6828",
  "react-tinymce": "static-1.55385",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10232",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54511",
  "tinymce-plugins": "static-1.57625",
  "tinymce-themes": "static-1.56481",
  "onboarding-data-sync-lib": "static-1.2041",
  "growth-onboarding-next-action-components": "static-1.2095",
  "user-context-client": "static-1.4655",
  "audio-components": "static-1.5993",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36905",
  "urlinator": "static-1.4589",
  "video-components": "static-1.13459",
  "outpost": "static-1.4228",
  "growth-onboarding-feedback-components": "static-1.6631",
  "content-media-composition-data-lib": "static-1.12525",
  "content-media-compositions": "static-2.16532",
  "media-bridge-lib": "static-1.19017",
  "commerce-tours-lib": "static-1.6196",
  "growth-onboarding-reliability": "static-1.5132",
  "sales-checkout-service-client": "static-1.3689",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21764",
  "sales-email-signature-service-client": "static-1.3898",
  "ts-utils-lib": "static-1.223",
  "crm-export-dialog": "static-1.6342",
  "crm-index-associations-lib": "static-1.6493",
  "crm-view-components": "static-1.423",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7379",
  "tanstack-virtual": "static-1.31",
  "nudge-custom-function-registry": "static-1.2449",
  "nudge-renderer-utils": "static-1.2768",
  "whisper-core-api": "static-1.6768",
  "InboxConnectUtils": "static-4.14954",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5665",
  "settings-content-modals": "static-1.46231",
  "crm_universal": "static-1.22095",
  "customer-data-email": "static-1.18123",
  "card-payment-highlight-lib": "static-1.37317",
  "card-subscription-highlight-lib": "static-1.39688",
  "commerce-contract-lib": "static-1.12269",
  "invoices-highlight-card-lib": "static-1.54876",
  "orders-highlight-card-lib": "static-1.21607",
  "products-highlight-card-lib": "static-1.18030",
  "quotes-highlight-card-lib": "static-1.72209",
  "crm-source-interpretation-lib": "static-1.5395",
  "utility-belt": "static-1.2586",
  "payments-enrollment-embed-lib": "static-1.23040",
  "stripe-embedded-components": "static-1.7596",
  "customer-data-rte": "static-1.33133",
  "cv-backend-services": "static-1.1555",
  "growth-onboarding-empty-states": "static-1.5830",
  "payments-post-enroll-local-storage-lib": "static-1.5160",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38299",
  "trials-service-types": "static-1.3957",
  "calling-orchestration-schema": "static-1.35981",
  "sales-views-client-types": "static-1.4309",
  "hub-http-contrib": "static-1.3093",
  "interframe": "static-3.4811",
  "tinymce-data": "static-1.40596",
  "ui-addon-sales-email": "static-1.5262",
  "layout-dnd-components": "static-1.12542",
  "layout-dnd-utils": "static-1.11517",
  "ui-brand-identity-lib": "static-1.15478",
  "NamespacedHubStyle": "static-2.9099",
  "meetings-connect-utils-lib": "static-1.7656",
  "social-insights-client-types": "static-1.22239",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4207",
  "checkout-sdk": "static-3.23776",
  "checkout-service-types": "static-1.3846",
  "company-details-components": "static-1.6247",
  "payment-method-components": "static-1.6946",
  "pricing-pages-ui-components": "static-1.14277",
  "quote-checkout-service-types": "static-1.3515",
  "upgrade-catalog-service-types": "static-1.3573",
  "access-control-lib": "static-1.10486",
  "EmailComponents": "static-1.54901",
  "EmailData": "static-1.53578",
  "redux-less": "static-2.9535",
  "sequences-lib": "static-1.8131",
  "ui-gdpr-components": "static-1.10401",
  "products-ui-components": "static-1.40265",
  "accounting-integrations-ui-components": "static-1.7144",
  "invoices-ui-lib": "static-1.54892",
  "commerce-products-api": "static-1.2373",
  "invoices-iframe-lib": "static-1.56950",
  "quotes-modal-lib": "static-1.102887",
  "quotes-ui-lib": "static-1.80930",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28405",
  "ContentData": "static-1.68588",
  "layout-data-lib": "static-1.9842",
  "hub-http-rxjs": "static-1.805",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3991",
  "billing-payments-client-types": "static-1.4043",
  "react-performance-metrics-lib": "static-1.608",
  "account-and-billing-fintech-outages": "static-3.18654",
  "pricing-pages-api": "static-1.14142",
  "ContentComponents": "static-2.71469",
  "marketing-contacts-lib": "static-1.10221",
  "marketing-email-service-types": "static-1.1938",
  "messaging-editing-lib": "static-1.46421",
  "messaging-usage-based-billing-components-lib": "static-1.1283",
  "automation-ui-source-apps": "static-1.19025",
  "automation-ui-types": "static-1.19943",
  "messaging-types-lib": "static-1.46158",
  "onboarding-settings-client": "static-1.4556",
  "sequences-client-types-lib": "static-1.7988",
  "commerce-tax-lib": "static-1.582",
  "price-books-api": "static-1.1000",
  "price-books-components": "static-1.1058",
  "property-description-translator": "static-1.3894",
  "ramp-editor": "static-1.264",
  "commerce-analytics-service-client": "static-1.3677",
  "totals-ui-components": "static-1.23747",
  "SalesContentIndexUI": "static-3.9324",
  "advanced-menus-core": "static-1.15208",
  "advanced-menus-lib": "static-1.12143",
  "ui-memberships-settings-lib": "static-1.34185",
  "segments-query-core": "static-1.1469",
  "eligibility-engine-service-types": "static-1.3238",
  "automation-ui-ubb": "static-1.5859",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7390",
  "data-token-views": "static-1.16475",
  "forms-utils-lib": "static-1.12679",
  "payments-embed-points-lib": "static-1.13142",
  "simple-menus-core": "static-1.15207",
  "simple-menus-lib": "static-1.16724",
  "videoconference-integration-components": "static-1.6897",
  "marketing-contacts-client": "static-1.7567",
  "automation-applications-service-types": "static-1.3554",
  "automation-platform-service-types": "static-1.2603",
  "ContentEditorUI": "static-2.77242",
  "short-messages-app-service-client": "static-1.4022",
  "web-interactives-components": "static-1.13847",
  "web-interactives-data": "static-1.13848",
  "messaging-shared-utils-lib": "static-1.732",
  "messaging-user-info-utils-lib": "static-1.902",
  "email-portal-health-service-types": "static-1.1030",
  "line-items-api": "static-1.774",
  "commerce-totals-service-types": "static-1.3859",
  "FireAlarmUi": "static-1.4553",
  "sales-templates-service-types-lib": "static-1.4210",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21879",
  "automation-ui-usage-tracking": "static-1.21342",
  "data-studio-ubb": "static-1.2868",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27151",
  "collaboration-sidebar": "static-1.57958",
  "content-management-data-lib": "static-1.5455",
  "copilot-plugins": "static-1.11242",
  "cta-picker": "static-1.36543",
  "customer-agent-discovery-components-lib": "static-1.3233",
  "editor-components": "static-1.13306",
  "editor-iframe-lib": "static-1.8476",
  "error-messaging-js": "static-1.5244",
  "FormsCommonComponents": "static-1.85991",
  "pictos": "static-7.185",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10698",
  "SharedLegalStrings": "static-1.1799",
  "smart-content-core": "static-1.42585",
  "smart-content-lib": "static-1.43238",
  "social-composer-lib": "static-1.59355",
  "structured-content-lib": "static-1.25330",
  "theme-previewer-lib": "static-1.53379",
  "tinymce-copilot": "static-1.16579",
  "xray-recommendation-lib": "static-1.7976",
  "automation-ui-routing": "static-1.21300",
  "sql-reporting-client-types": "static-1.5678",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42304",
  "campaigns-utils-lib": "static-1.3238",
  "reporting-enablement": "static-1.23102",
  "chatspot-widget-iframe": "static-1.21506",
  "collaboration-sidebar-common": "static-1.2755",
  "forms-ai-lib": "static-1.4396",
  "codemirror-dlb": "static-1.58801",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6484",
  "report-customization-components": "static-1.13309",
  "data-quality-ui-library": "static-1.13180",
  "html-to-image": "static-1.55",
  "reporting-filters": "static-1.458",
  "reporting-insights-lib": "static-1.1892"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12426",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.473",
  "data-fetching-client": "/data-fetching-client/static-1.9716",
  "foundations-components": "/foundations-components/static-1.8030",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1055",
  "foundations-theming": "/foundations-theming/static-1.4476",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8068",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10086",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11525",
  "I18n": "/I18n/static-7.1633",
  "jasmine-runner": "/jasmine-runner/static-1.6515",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12487",
  "quartz": "/quartz/static-1.7093",
  "react-dlb": "/react-dlb/static-1.80",
  "react-rhumb": "/react-rhumb/static-1.16729",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2910",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9708",
  "settings-ui-lib": "/settings-ui-lib/static-1.12571",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7233",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11203",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9593",
  "unified-auth": "/unified-auth/static-1.554",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.836",
  "usage-tracker": "/usage-tracker/static-1.7401",
  "usage-tracker-core": "/usage-tracker-core/static-1.7251",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8143",
  "hub-http": "/hub-http/static-1.6274",
  "integrations-lib": "/integrations-lib/static-1.16329",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19951",
  "property-management-iframe": "/property-management-iframe/static-1.13326",
  "quartz-config": "/quartz-config/static-1.871",
  "quartz-core": "/quartz-core/static-1.6312",
  "quartz-routing": "/quartz-routing/static-1.523",
  "quick-fetch": "/quick-fetch/static-1.3958",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4704",
  "ts-schema": "/ts-schema/static-1.4120",
  "ui-universal-auth": "/ui-universal-auth/static-1.9040",
  "UIComponents": "/UIComponents/static-3.8471",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3440",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3370",
  "quartz-webpack": "/quartz-webpack/static-1.3317",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.171",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4299",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4921",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2192",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9475",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5384",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2073",
  "ui-fonts": "/ui-fonts/static-1.787",
  "ui-images": "/ui-images/static-2.1165",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2959",
  "foundations-theming-base": "/foundations-theming-base/static-1.3461",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.765",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3179",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4377",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9095",
  "ai-rendering-library": "/ai-rendering-library/static-1.10346",
  "chirp-fetch": "/chirp-fetch/static-1.1939",
  "connections-embed-lib": "/connections-embed-lib/static-1.1086",
  "copilot-toolkit": "/copilot-toolkit/static-1.11269",
  "feedback-loader": "/feedback-loader/static-1.29390",
  "laboratory-lib": "/laboratory-lib/static-3.7207",
  "marketplace-embed": "/marketplace-embed/static-1.22232",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9846",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19906",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14121",
  "sanitize-text": "/sanitize-text/static-1.8194",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8755",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5815",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5087",
  "wootric-nps": "/wootric-nps/static-1.7022",
  "quartz-head": "/quartz-head/static-1.758",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4703",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4205",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2525",
  "reporting-data": "/reporting-data/static-1.67775",
  "cssUtils": "/cssUtils/static-1.804",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11832",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10260",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10416",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7391",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18483",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4565",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5513",
  "quartz-i18n": "/quartz-i18n/static-1.768",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.28",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.385",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.520",
  "slack-ui-library": "/slack-ui-library/static-1.10443",
  "fsm": "/fsm/static-1.3782",
  "customer-data-objects": "/customer-data-objects/static-1.7728",
  "property-translator": "/property-translator/static-1.5450",
  "hs-locale-management": "/hs-locale-management/static-1.121",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7978",
  "hs-promise-utils": "/hs-promise-utils/static-1.5643",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4929",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13744",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5655",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7833",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4528",
  "superstore": "/superstore/static-1.4812",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10263",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7965",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4691",
  "immutable-less": "/immutable-less/static-1.4704",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17358",
  "nav-meta": "/nav-meta/static-1.29802",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10298",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18068",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3886",
  "property-management-common": "/property-management-common/static-1.5614",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9111",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.768",
  "quartz-test": "/quartz-test/static-1.768",
  "quartz-tracking": "/quartz-tracking/static-1.472",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.114",
  "bender-build-tools": "/bender-build-tools/static-1.3254",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21515",
  "ContentUtils": "/ContentUtils/static-1.68513",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13083",
  "sassPrefix": "/sassPrefix/static-1.157",
  "breeze-engine-core": "/breeze-engine-core/static-1.112",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.136",
  "avatar-components": "/avatar-components/static-1.2550",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39975",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13220",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14508",
  "ExportDialog": "/ExportDialog/static-6.10437",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41440",
  "reporting-snowflake": "/reporting-snowflake/static-1.56393",
  "reporting-ui-components": "/reporting-ui-components/static-2.65046",
  "reporting-visualizations": "/reporting-visualizations/static-1.59851",
  "ui-addon-teams": "/ui-addon-teams/static-1.21625",
  "magpie-lib": "/magpie-lib/static-1.5585",
  "navigation-components": "/navigation-components/static-1.18165",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.834",
  "magpie-types": "/magpie-types/static-1.5045",
  "simple-logging-lib": "/simple-logging-lib/static-1.3102",
  "ai-studio-lib": "/ai-studio-lib/static-1.11761",
  "app-governance-lib": "/app-governance-lib/static-1.1715",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10564",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8052",
  "ui-product-approvals": "/ui-product-approvals/static-1.28298",
  "ui-tool-access": "/ui-tool-access/static-1.10200",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9170",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5818",
  "usage-tracker-public": "/usage-tracker-public/static-1.7212",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3626",
  "persist-promise": "/persist-promise/static-1.3750",
  "reference-resolvers": "/reference-resolvers/static-1.8223",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3977",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.388",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3068",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2920",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "atom": "/atom/static-1.5126",
  "purchase-motions-components": "/purchase-motions-components/static-1.6006",
  "salesImages": "/salesImages/static-1.526",
  "batch-promise": "/batch-promise/static-1.1593",
  "crm-component-utils": "/crm-component-utils/static-1.39212",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5939",
  "customer-data-properties": "/customer-data-properties/static-1.51746",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6939",
  "property-value-citations": "/property-value-citations/static-1.2360",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8148",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9109",
  "navigation-messaging": "/navigation-messaging/static-1.7492",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10084",
  "cms-field-types": "/cms-field-types/static-1.4864",
  "content-icons-ui": "/content-icons-ui/static-1.2239",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9877",
  "events-data-lib": "/events-data-lib/static-1.279",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7300",
  "crm-message-bus": "/crm-message-bus/static-1.43102",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22410",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4772",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4045",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6844",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1033",
  "onboarding-tours": "/onboarding-tours/static-1.16700",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13824",
  "academy-common-lib": "/academy-common-lib/static-1.13968",
  "content-assistance-lib": "/content-assistance-lib/static-1.7830",
  "dashboard-lib": "/dashboard-lib/static-1.81737",
  "file-manager-components": "/file-manager-components/static-1.23754",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18569",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18371",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18363",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19919",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8756",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4814",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11104",
  "user-context": "/user-context/static-1.5159",
  "growth-payments-core": "/growth-payments-core/static-1.25524",
  "reporting-plugins": "/reporting-plugins/static-1.10400",
  "reporting-reports": "/reporting-reports/static-1.67453",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.775",
  "nest": "/nest/static-1.283",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10679",
  "framework-listing-lib": "/framework-listing-lib/static-2.28828",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30842",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4302",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.193",
  "onboarding-scopes": "/onboarding-scopes/static-1.6513",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4914",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7712",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15000",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3630",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9408",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6009",
  "signup-constants": "/signup-constants/static-1.18949",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8105",
  "card-properties-lib": "/card-properties-lib/static-1.44348",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37265",
  "crm-actions": "/crm-actions/static-1.6389",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43738",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9413",
  "customer-data-tracking": "/customer-data-tracking/static-1.6941",
  "hs-resources": "/hs-resources/static-1.219",
  "pulse": "/pulse/static-1.637",
  "calling-global-api": "/calling-global-api/static-1.64688",
  "calling-internal-common": "/calling-internal-common/static-1.31355",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66070",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58364",
  "commerce-products-lib": "/commerce-products-lib/static-1.9747",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3838",
  "crm-links": "/crm-links/static-1.6357",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4180",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4263",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.684",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3732",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48920",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4006",
  "smart-property-lib": "/smart-property-lib/static-1.7372",
  "tiered-pricing": "/tiered-pricing/static-1.1330",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11041",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.58",
  "react-dnd-compat": "/react-dnd-compat/static-1.4665",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1032",
  "growth-data-modal": "/growth-data-modal/static-1.5507",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3118",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2067",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.766",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7644",
  "academy-service-client": "/academy-service-client/static-1.3734",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39253",
  "FileManagerLib": "/FileManagerLib/static-1.39394",
  "video-embed": "/video-embed/static-1.35949",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28703",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11457",
  "video-data-lib": "/video-data-lib/static-1.35115",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8516",
  "payment-link-components": "/payment-link-components/static-1.23646",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9938",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24485",
  "viral-links-lib": "/viral-links-lib/static-1.7120",
  "data-token-picker": "/data-token-picker/static-1.16494",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.278",
  "timezone-utils": "/timezone-utils/static-2.5295",
  "seat-types-lib": "/seat-types-lib/static-1.136",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17687",
  "ui-addon-opt": "/ui-addon-opt/static-4.8414",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9256",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25562",
  "framework-data-table": "/framework-data-table/static-2.12033",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6912",
  "nudge-client-utils": "/nudge-client-utils/static-1.2692",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1126",
  "switchboard-lib": "/switchboard-lib/static-1.272",
  "app-users-service-client": "/app-users-service-client/static-1.5652",
  "app-users-service-types": "/app-users-service-types/static-1.5060",
  "mini-checkout-client": "/mini-checkout-client/static-1.26933",
  "onboarding-utils": "/onboarding-utils/static-1.5409",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2051",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28688",
  "edison-service-client-types": "/edison-service-client-types/static-1.440",
  "crm_data": "/crm_data/static-4.92120",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46157",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16490",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4310",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19238",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18658",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10512",
  "crm-fe-perf": "/crm-fe-perf/static-1.22954",
  "event-emitter": "/event-emitter/static-1.999",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.140",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31362",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11088",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6593",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1204",
  "commerce-permissions": "/commerce-permissions/static-1.825",
  "products-iframe-lib": "/products-iframe-lib/static-1.8076",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10468",
  "data-agent-kit": "/data-agent-kit/static-1.274",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10169",
  "policy-lib": "/policy-lib/static-1.6828",
  "react-tinymce": "/react-tinymce/static-1.55385",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10232",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54511",
  "tinymce-plugins": "/tinymce-plugins/static-1.57625",
  "tinymce-themes": "/tinymce-themes/static-1.56481",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2041",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2095",
  "user-context-client": "/user-context-client/static-1.4655",
  "audio-components": "/audio-components/static-1.5993",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36905",
  "urlinator": "/urlinator/static-1.4589",
  "video-components": "/video-components/static-1.13459",
  "outpost": "/outpost/static-1.4228",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6631",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12525",
  "content-media-compositions": "/content-media-compositions/static-2.16532",
  "media-bridge-lib": "/media-bridge-lib/static-1.19017",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6196",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5132",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21764",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3898",
  "ts-utils-lib": "/ts-utils-lib/static-1.223",
  "crm-export-dialog": "/crm-export-dialog/static-1.6342",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6493",
  "crm-view-components": "/crm-view-components/static-1.423",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7379",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2449",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2768",
  "whisper-core-api": "/whisper-core-api/static-1.6768",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14954",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5665",
  "settings-content-modals": "/settings-content-modals/static-1.46231",
  "crm_universal": "/crm_universal/static-1.22095",
  "customer-data-email": "/customer-data-email/static-1.18123",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37317",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39688",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12269",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54876",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21607",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18030",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72209",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5395",
  "utility-belt": "/utility-belt/static-1.2586",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23040",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7596",
  "customer-data-rte": "/customer-data-rte/static-1.33133",
  "cv-backend-services": "/cv-backend-services/static-1.1555",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5830",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5160",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38299",
  "trials-service-types": "/trials-service-types/static-1.3957",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35981",
  "sales-views-client-types": "/sales-views-client-types/static-1.4309",
  "hub-http-contrib": "/hub-http-contrib/static-1.3093",
  "interframe": "/interframe/static-3.4811",
  "tinymce-data": "/tinymce-data/static-1.40596",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5262",
  "layout-dnd-components": "/layout-dnd-components/static-1.12542",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11517",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15478",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9099",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7656",
  "social-insights-client-types": "/social-insights-client-types/static-1.22239",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4207",
  "checkout-sdk": "/checkout-sdk/static-3.23776",
  "checkout-service-types": "/checkout-service-types/static-1.3846",
  "company-details-components": "/company-details-components/static-1.6247",
  "payment-method-components": "/payment-method-components/static-1.6946",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14277",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3515",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3573",
  "access-control-lib": "/access-control-lib/static-1.10486",
  "EmailComponents": "/EmailComponents/static-1.54901",
  "EmailData": "/EmailData/static-1.53578",
  "redux-less": "/redux-less/static-2.9535",
  "sequences-lib": "/sequences-lib/static-1.8131",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10401",
  "products-ui-components": "/products-ui-components/static-1.40265",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7144",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54892",
  "commerce-products-api": "/commerce-products-api/static-1.2373",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56950",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102887",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80930",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28405",
  "ContentData": "/ContentData/static-1.68588",
  "layout-data-lib": "/layout-data-lib/static-1.9842",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.805",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3991",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4043",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.608",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18654",
  "pricing-pages-api": "/pricing-pages-api/static-1.14142",
  "ContentComponents": "/ContentComponents/static-2.71469",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10221",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1938",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46421",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1283",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19025",
  "automation-ui-types": "/automation-ui-types/static-1.19943",
  "messaging-types-lib": "/messaging-types-lib/static-1.46158",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4556",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7988",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.582",
  "price-books-api": "/price-books-api/static-1.1000",
  "price-books-components": "/price-books-components/static-1.1058",
  "property-description-translator": "/property-description-translator/static-1.3894",
  "ramp-editor": "/ramp-editor/static-1.264",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3677",
  "totals-ui-components": "/totals-ui-components/static-1.23747",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9324",
  "advanced-menus-core": "/advanced-menus-core/static-1.15208",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12143",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34185",
  "segments-query-core": "/segments-query-core/static-1.1469",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3238",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5859",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7390",
  "data-token-views": "/data-token-views/static-1.16475",
  "forms-utils-lib": "/forms-utils-lib/static-1.12679",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13142",
  "simple-menus-core": "/simple-menus-core/static-1.15207",
  "simple-menus-lib": "/simple-menus-lib/static-1.16724",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6897",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7567",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3554",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2603",
  "ContentEditorUI": "/ContentEditorUI/static-2.77242",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4022",
  "web-interactives-components": "/web-interactives-components/static-1.13847",
  "web-interactives-data": "/web-interactives-data/static-1.13848",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.732",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.902",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1030",
  "line-items-api": "/line-items-api/static-1.774",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3859",
  "FireAlarmUi": "/FireAlarmUi/static-1.4553",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4210",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21879",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21342",
  "data-studio-ubb": "/data-studio-ubb/static-1.2868",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27151",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57958",
  "content-management-data-lib": "/content-management-data-lib/static-1.5455",
  "copilot-plugins": "/copilot-plugins/static-1.11242",
  "cta-picker": "/cta-picker/static-1.36543",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3233",
  "editor-components": "/editor-components/static-1.13306",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8476",
  "error-messaging-js": "/error-messaging-js/static-1.5244",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85991",
  "pictos": "/pictos/static-7.185",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10698",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1799",
  "smart-content-core": "/smart-content-core/static-1.42585",
  "smart-content-lib": "/smart-content-lib/static-1.43238",
  "social-composer-lib": "/social-composer-lib/static-1.59355",
  "structured-content-lib": "/structured-content-lib/static-1.25330",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53379",
  "tinymce-copilot": "/tinymce-copilot/static-1.16579",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7976",
  "automation-ui-routing": "/automation-ui-routing/static-1.21300",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5678",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42304",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3238",
  "reporting-enablement": "/reporting-enablement/static-1.23102",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21506",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2755",
  "forms-ai-lib": "/forms-ai-lib/static-1.4396",
  "codemirror-dlb": "/codemirror-dlb/static-1.58801",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6484",
  "report-customization-components": "/report-customization-components/static-1.13309",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13180",
  "html-to-image": "/html-to-image/static-1.55",
  "reporting-filters": "/reporting-filters/static-1.458",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1892"
}
};
